<section class="page">
  <header class="page-header">
    <h2>Voir les capteurs fabriqués</h2>
    <button type="button" class="btn-refresh" (click)="refresh()">Rafraîchir</button>
  </header>

  <div class="toolbar">
    <label for="filter">Filtre</label>
    <input
      id="filter"
      type="text"
      [(ngModel)]="filter"
      (ngModelChange)="onFilterChange()"
      placeholder="Numéro de série, commande, commentaire"
    />
  </div>

  @if (success) {
    <p class="success">{{ success }}</p>
  }

  @if (loading) {
    <p>Chargement...</p>
  } @else if (error) {
    <p class="error">{{ error }}</p>
  } @else {
    <p class="meta">
      {{ filteredCapteurs.length }} résultat(s)
      @if (filteredCapteurs.length > 0) {
        <span> - affichage {{ pageStartIndex }} à {{ pageEndIndex }}</span>
      }
    </p>

    @if (filteredCapteurs.length === 0) {
      <p>Aucun capteur fabriqué trouvé pour ce filtre.</p>
    } @else {
      <div class="table-wrap panel">
        <table>
          <thead>
            <tr>
              <th>Numéro de série</th>
              <th>Statut</th>
              <th>Code cartouche A</th>
              <th>Code cartouche B</th>
              <th>Date envoi</th>
              <th>Date de retour</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (capteur of paginatedCapteurs; track capteur.id) {
              <tr>
                <td>{{ capteur.numero_serie }}</td>
                <td>{{ getStatutNom(capteur.statut_capteur_id) || '-' }}</td>
                <td>{{ fetchCartoucheNom(capteur.cartouche_a) || '-' }}</td>
                <td>{{ fetchCartoucheNom(capteur.cartouche_b) || '-' }}</td>
                <td>{{ capteur.date_expedition ? (capteur.date_expedition | date:'dd/MM/yyyy':'UTC':'fr-FR') : '-' }}</td>
                <td>{{ capteur.date_retour ? (capteur.date_retour | date:'dd/MM/yyyy':'UTC':'fr-FR') : '-' }}</td>
                <td class="actions-cell">
                  <button
                    type="button"
                    class="edit"
                    [disabled]="loading"
                    (click)="editCapteur(capteur)"
                  >
                    Éditer
                  </button>
                  <button
                    type="button"
                    class="danger"
                    [disabled]="loading || deletingId === capteur.id"
                    (click)="deleteCapteur(capteur)"
                  >
                    {{ deletingId === capteur.id ? 'Suppression...' : 'Supprimer' }}
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    @if (totalPages > 1) {
      <div class="pagination">
        <button type="button" [disabled]="page === 1" (click)="previousPage()">Précédent</button>
        <span>Page {{ page }} / {{ totalPages }}</span>
        <button type="button" [disabled]="page === totalPages" (click)="nextPage()">Suivant</button>
      </div>
    }
  }
</section>
